import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import {
  Counter,
  Placeholder,
  TextareaControl,
  TextareaWrapper
} from './style';

const Textarea = ({ icon, isShowPassword, readonly, ...props }) => {
  useEffect(() => {
    if (document.getElementById('note-textarea') && readonly) {
      document.getElementById('note-textarea').readOnly = readonly;
    }
  }, [readonly]);
  return (
    <TextareaWrapper
      value={props.value}
      variant={props.variant}
      status={props.status}
      phoneSection={props.phoneSection}
    >
      {props.variant === 'form' && (
        <Placeholder hasValue={props.value?.length > 0} status={props.status}>
          {props.placeholder}
        </Placeholder>
      )}
      {props.maxLength && !props.isOnLeadDetail && (
        <Counter status={props.status}>
          {`${props.value?.length?.toString()}  /  ${props.maxLength.toString()}`}
        </Counter>
      )}
      <TextareaControl
        {...props}
        readonly={props.readonly}
        id="note-textarea"
      />
    </TextareaWrapper>
  );
};

Textarea.defaultProps = {
  innerTooltip: false,
  isOnLeadDetail: false
};

Textarea.propTypes = {
  variant: PropTypes.oneOf(['default', 'form', 'leadDetail']),
  maxLength: PropTypes.number,
  status: PropTypes.oneOf(['invalid']),
  isOnLeadDetail: PropTypes.bool
};

export default Textarea;
